import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { DeleteIcon } from "../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const CustomerCreateHelp = () => (
  <>
    <Typography variant="subtitle1">
      Creating a new Customer sends out an email invitation to specified email
      address, asking the new user to complete signup process. The new User will
      not have access until they complete registration. They will need access to
      their email to complete the process.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Account: </strong> Select the Account to which the user should
          have access to. They will have access only to the selected Account's
          data. Account cannot be changed once the record is created.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Email: </strong> Email address is used to complete new User
          registration process. Each user must have a unique email address,
          since it is used as username to login into the platform. Email cannot
          be changed once the User record is created.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Phone: </strong> Phone number for record keeping.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Access Permissions: </strong> <br />
          - View Invoices: if checked, the user will have read-only access to
          view pending and paid/completed invoices. <br />
          - User Management: if checked: the user will read-only access to view
          other users in their own account. <br />
        </Typography>
      </li>
    </ul>
  </>
);

export const CustomerEditHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="subtitle1">
        Customer info is locked. Only they user can edit their Profile info such
        as name and phone.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Email: </strong> Email address is used to complete new User
            registration process. Each user must have a unique email address,
            since it is used as username to login into the platform. Email
            cannot be changed once the User record is created.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Access Permissions: </strong> <br />
            - View Invoices: if checked, the user will have read-only access to
            view pending and paid/completed invoices. <br />
            - User Management: if checked: the user will read-only access to
            view other users in their own account. <br />
          </Typography>
        </li>
        <li>
          <Typography>
            <DeleteIcon className={classes.icon} />
            <strong> DELETE: </strong>
            Removes user's access to the selected Account's data.
          </Typography>
        </li>
      </ul>
    </>
  );
};
